import { render, staticRenderFns } from "./PublishProductModal.vue?vue&type=template&id=4936d68b&"
import script from "./PublishProductModal.vue?vue&type=script&lang=js&"
export * from "./PublishProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports